module.exports = {
    bind: function() {
        $(this.el).fileinput({
            overwriteInitial: true,
            maxFileSize: 1500,
            showClose: false,
            showCaption: false,
            showRemove: false,
            showUpload: false,
            browseLabel: '',
            browseIcon: 'Change Picture',
            browseClass: 'btn btn-default',
            elErrorContainer: '#kv-avatar-errors',
            msgErrorClass: 'alert alert-block alert-danger',
            defaultPreviewContent: '<img src="/images/temp_no_image.png" style="width:175px">',
            allowedFileExtensions: ["jpg", "png", "gif"]
        })
        .on('filebatchselected', function () {
            // Ajax Call
            console.log('Call Back-end');
        });
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/directives/fileinput.js